import { Drawer } from "@mui/material";
import React from "react";
import { scrollToElement } from "../../../services/helpers/commonHelpers";
import SidebarInnerList from "../SidebarInnerList/SidebarInnerList";
import Button from "../../atoms/Button/Button";
import MenuIcon from "@mui/icons-material/Menu";
import classNames from "classnames";
import { CurrentSidebarItemState } from "../../pages/MainPage/MainPage";
import { SidebarMenuItemType } from "../../../services/helpers/types";

interface SidebarTabletViewProps {
  isSidebarOpen: boolean;
  isSidebarFullScreen: boolean;
  isTabletView: boolean;
  currentSidebarItem: CurrentSidebarItemState;
  sidebarItems: SidebarMenuItemType[];
  isSidebarLoading: boolean;
  isAiAssistantOpen: boolean;
  isDictationOpen: boolean;
  onAiAssistantOpen: () => void;
  onFullScreenOpen: () => void;
  onTabletOpen: () => void;
  onSearch: (searchValue?: string) => void;
  onPageSelect: (itemID?: number) => void;
  onSidebarTabletExpand: () => void;
  onSettingsOpen: () => void;
  onPageCreate: (itemID: number) => void;
  onEditToggle: () => void;
  onDictationOpen: () => void;
}

const SidebarTabletView = (props: SidebarTabletViewProps) => {
  const {
    isSidebarOpen,
    isSidebarFullScreen,
    isTabletView,
    currentSidebarItem,
    sidebarItems,
    isSidebarLoading,
    isAiAssistantOpen,
    isDictationOpen,
    onAiAssistantOpen,
    onFullScreenOpen,
    onTabletOpen,
    onSearch,
    onPageSelect,
    onSidebarTabletExpand,
    onSettingsOpen,
    onPageCreate,
    onEditToggle,
    onDictationOpen,
  } = props;

  const innerClassName = classNames("dui-sidebar-inner", {
    "dui-sidebar-inner-tablet": isTabletView,
  });

  return (
    <div className="dui-sidebar-wrapper">
      <Drawer
        anchor="left"
        open={isSidebarOpen}
        variant="temporary"
        className={innerClassName}
        onLoad={() =>
          scrollToElement("dui-sidebar-mid", "dui-sidebar-item-active")
        }
      >
        <SidebarInnerList
          currentSidebarItem={currentSidebarItem}
          sidebarItems={sidebarItems}
          isSidebarFullScreen={isSidebarFullScreen}
          isTabletView={isTabletView}
          isSidebarLoading={isSidebarLoading}
          isAiAssistantOpen={isAiAssistantOpen}
          isDictationOpen={isDictationOpen}
          onAiAssistantOpen={onAiAssistantOpen}
          onFullScreenOpen={onFullScreenOpen}
          onTabletOpen={onTabletOpen}
          onSearch={onSearch}
          onPageSelect={onPageSelect}
          onSettingsClick={onSettingsOpen}
          onPageCreate={onPageCreate}
          onEditToggle={onEditToggle}
          onDictationOpen={onDictationOpen}
        />
      </Drawer>
      <div className="dui-sidebar-hamburger">
        <Button
          icon={<MenuIcon />}
          type="primary"
          onClick={() => {
            onSidebarTabletExpand();
          }}
        />
      </div>
    </div>
  );
};

export default SidebarTabletView;
